import api from '@pray/shared/utils/api';

export async function getAllDonationFunds({
  artistId = '',
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  onlyEnabledFunds,
  onlyNonDefaultFunds,
} = {}) {
  const params = {};

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  if (onlyEnabledFunds !== undefined) params.only_enabled_funds = onlyEnabledFunds;

  if (onlyNonDefaultFunds !== undefined) params.only_non_default_funds = onlyNonDefaultFunds;

  const url = `/web/studio/artists/${artistId}/funds`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
